import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../index.css';
import registerImg from '../../src/RapidMind 2025.png';

const RegisterTest = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get user data from navigation state or fallback to mock data
  const [userData, setUserData] = useState({
    firstName: 'Admin',
    lastName: 'Test',
    email: 'admin@test.com',
    gender: 'male',
    privateCode: '123456'
  });

  // Use actual user data from registration if available
  useEffect(() => {
    if (location.state?.user) {
      setUserData(location.state.user);
      // Also store in localStorage for persistence
      localStorage.setItem('user', JSON.stringify(location.state.user));
    }
  }, [location.state]);

  // On mount, store userData in localStorage to simulate registration storing privateCode
  React.useEffect(() => {
    localStorage.setItem('user', JSON.stringify(userData));
  }, [userData]);

  const [copied, setCopied] = useState(false);
  const [showPrivateCode, setShowPrivateCode] = useState(true);
  const [hoveredButton, setHoveredButton] = useState(null);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const handleContinue = () => {
    navigate('/profile');
  };

  return (
    <div className="register-form-container">
      <img id='registerImg' src={registerImg} alt="RapidMind Logo" />

      {/* Congratulatory Message */}
      <div className="congratulation-message">
        <div className="congratulation-header">
          <h2>🎉 Félicitations ! 🎉</h2>
        </div>

        <div className="congratulation-content">
          <p className="greeting">
            {userData.gender === 'male' ? 'Monsieur' : userData.gender === 'female' ? 'Madame' : ''} {userData.firstName},
          </p>

          <p className="message-text">
            Merci d'avoir rejoint la communauté <strong>RapidMind</strong> ! 🚀<br />
            Nous sommes ravis de vous compter parmi nos membres et sommes impatients de vous accompagner dans votre parcours.
          </p>

          <p className="message-text">
            Nous avons hâte de vous partager de nouveaux outils et ressources pour vous aider à atteindre vos objectifs. 🧠💡
          </p>

          <p className="welcome-text">
            Bienvenue à bord ! ✨
          </p>

          <p className="signature">
            L'équipe RapidMind
          </p>
        </div>
      </div>

      {/* Private Code Section */}
      <div className="private-code-section">
        <h3>Votre code privé {' '}
          <span
            role="button"
            aria-label="Toggle private code visibility"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPrivateCode(!showPrivateCode)}
            title={showPrivateCode ? 'Masquer le code' : 'Afficher le code'}
          >
            {showPrivateCode ? '👁️' : '🙈'}
          </span>
        </h3>
        <div className="code-display">
          <span className="code">
            {showPrivateCode
              ? (userData?.privateCode || 'Code non disponible')
              : '••••••'
            }
          </span>
          <button
            className="copy-button"
            onClick={() => copyToClipboard(userData?.privateCode || '')}
            title="Copier le code"
            disabled={!userData?.privateCode}
          >
            {copied ? '✓ Copié' : '📋 Copier'}
          </button>
        </div>
        <p className="warning">
          ⚠️ <strong>Important :</strong> Gardez ce code en sécurité et ne le partagez avec personne.
          Il vous sera demandé pour certaines fonctionnalités de l'application.
        </p>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={handleContinue}
        className="continue-button"
        style={{
          backgroundColor: hoveredButton === 'profile' ? 'yellow' : 'green',
          borderRadius: '15px',
          color: hoveredButton === 'profile' ? 'black' : 'white',
          padding: '10px 20px',
          border: 'none',
          cursor: 'pointer',
          marginRight: '10px',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={() => setHoveredButton('profile')}
        onMouseLeave={() => setHoveredButton(null)}
      >
        Continuer vers mon profil
      </button>
      <button
        onClick={() => navigate('/')}
        className="continue-home-button"
        style={{
          backgroundColor: hoveredButton === 'home' ? 'green' : 'yellow',
          borderRadius: '15px',
          color: hoveredButton === 'home' ? 'white' : 'black',
          padding: '10px 20px',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={() => setHoveredButton('home')}
        onMouseLeave={() => setHoveredButton(null)}
      >
        Continuer vers Home
      </button>

      {/* Test Controls */}
      <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ccc', borderRadius: '10px' }}>
        <h3>🧪 Test Controls</h3>
        <p><strong>Current State:</strong></p>
        <ul>
          <li>Private Code Visible: {showPrivateCode ? '✅ Yes' : '❌ No'}</li>
          <li>Code Value: {userData.privateCode}</li>
          <li>Hovered Button: {hoveredButton || 'None'}</li>
          <li>Copy Status: {copied ? '✅ Copied' : '❌ Not copied'}</li>
        </ul>

        <div style={{ marginTop: '10px' }}>
          <button
            onClick={() => setShowPrivateCode(!showPrivateCode)}
            style={{ marginRight: '10px', padding: '5px 10px' }}
          >
            Toggle Code Visibility
          </button>
          <button
            onClick={() => copyToClipboard(userData.privateCode)}
            style={{ padding: '5px 10px' }}
          >
            Test Copy Function
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterTest;
